







































import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {Api, Typeform_Form} from "@/core/services/MedicaPro/Api";
import {Client, MeasurementTypeConfiguration} from "@/core/services/MedicaPro/models";

@Component({
    components: {}
})
export default class MeasurementListCreateNewRow extends BaseComponent {

    // Bindings to parent
    @Prop() measurementIdentifier!: string;
    @Prop() measurementTypeConfiguration?: MeasurementTypeConfiguration;
    @Prop() client!: Client;

    // Bindings to view
    public isReady = false;
    public showTypeFormBtn = false;
    public isCopying = false;

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.showTypeFormBtn = this.measurementTypeConfiguration !== undefined;
        this.isReady = true;
    }

    public onCreateBtnClicked() {
        this.$emit('createManually');
    }

    public onCopyLinkBtnClicked() {
        this.isCopying = true;
        Api.integrationsTypeform().getFormUrlGetByFormId(this.measurementTypeConfiguration!.typeform_identifier!)
            .clientId(this.client.id!)
            .find(value => {
                navigator.clipboard.writeText(value[0].value ?? '');
                this.$toast('Link tilføjet til clipboard');
                this.isCopying = false;
            });
    }

}
